import { Navigate, Route, Routes } from 'react-router-dom'
import DashboardPage from './pages/DashboardPage'
import ManagePage from './pages/ManagePage'

const ReleaseCheckRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/manage" element={<ManagePage />} />
      <Route path="*" element={<Navigate to="/release-check" replace />} />
    </Routes>
  )
}

export default ReleaseCheckRoutes
